



















































import Vue from 'vue'
import { Table, TableColumn, Button } from 'element-ui'
import './TeamRoleList.scss'
import SubscribeTeamRoles from '@/mixins/SubscribeTeamRoles'
import { KeyDict } from '@/types'
import { TeamRole, AbilityAction, AbilitySubject, AbilityRole, abilitiesToTeamRole } from '@/abilitiesByRole'
import { sortBy } from 'lodash'
import AddEditTeamRole from '@/components/TeamRoleList/AddEditTeamRole'
import roleNames, { roleDescription } from '@/roleNames'

interface TeamRoleItem {
  id: string,
  name: string,
  description: string
}

export default Vue.extend({
  name: 'TeamRoleList',
  mixins: [ SubscribeTeamRoles ],
  props: {
    createNew: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
    Object.values(AbilityRole).forEach((abilityRole) => {
      this.standardRoles[abilityRole] = abilitiesToTeamRole(abilityRole)
      this.standardRoles[abilityRole].name = roleNames(abilityRole)
      this.standardRoles[abilityRole].description = roleDescription(abilityRole)
    })
  },
  data: () => ({
    showAddEditModal: false,
    selectedTeamRole: null as null|TeamRole,
    selectedTeamRoleId: '',
    standardRoles: {} as KeyDict<TeamRole>
  }),
  watch: {
    createNew (newVal: boolean) {
      if (newVal) this.addRole()
    }
  },
  computed: {
    canEditTeamRole (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.TeamSettings)
    },
    canDeleteTeamRole (): boolean {
      return this.$can(AbilityAction.Delete, AbilitySubject.TeamSettings)
    },
    //FIXME Already defined by SubscribeTeamRoles mixin. But we need it to prevent TS from complaining that `this.activeTeam` doesn't exist.
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    teamRoles (): KeyDict<TeamRole> {
      return this.$store.direct.state.abilities.teamRoles
    },
    sortedTeamRoles (): TeamRoleItem[] {
      const rolesList: TeamRoleItem[] = []
      const addAsTeamRoleItem = ([roleId, role]) => {
        if (roleId === AbilityRole.SuperUser) return
        const isPredefinedRole = Object.values(AbilityRole).includes(roleId)
        const name = isPredefinedRole ? roleNames(roleId) : role.name
        const description = isPredefinedRole ? roleDescription(roleId) : role.description
        const roleItem: TeamRoleItem = {
          id: roleId,
          name,
          description
        }
        rolesList.push(roleItem)
      }
      Object.entries(this.standardRoles).forEach(addAsTeamRoleItem)
      Object.entries(this.teamRoles).forEach(addAsTeamRoleItem)
      return sortBy(rolesList, 'name')
    }
  },
  methods: {
    deleteRole (roleId: string) {
      this.$confirm('Are you sure you want to delete this Team Role?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.direct.dispatch.abilities.deleteRole(roleId).then(() => {
          this.$message({
            type: 'success',
            message: 'Team Role deleted'
          })
        }).catch(error => {
          this.$message({
            type: 'error',
            message: 'Failed to delete Team Role: ' + error
          })
          console.error('Error deleteRole', error)
        })
      }).catch(error => {
        console.log('remove team role cancelled', error)
      })
    },
    addRole () {
      this.selectedTeamRole = new TeamRole({
        team_id: this.activeTeam,
        name: '',
        description: '',
        abilities: {}
      })
      this.selectedTeamRoleId = ''
      this.showAddEditModal = true
    },
    editRole (roleId: string) {
      if (roleId === '') {
        console.error('Team role id required for editing.')
        return
      }
      const teamRole = this.teamRoles[roleId] ?? this.standardRoles[roleId]
      if (teamRole === undefined) {
        console.warn(`Team role with id ${roleId} is no longer available.`)
        return
      }
      // Provide the modal with a copy so it doesn't modify the TeamRole directly.
      this.selectedTeamRole = new TeamRole(teamRole)
      this.selectedTeamRoleId = roleId
      this.showAddEditModal = true
    },
    addEditDone (teamRole: TeamRole) {
      if (!this.isStandardRole(this.selectedTeamRoleId)) {
        if (this.selectedTeamRoleId === '') {
          this.$store.direct.dispatch.abilities.addRole(teamRole).then(() => {
            this.$message({
              type: 'success',
              message: 'Team Role added'
            })
          }).catch(error => {
            this.$message({
              type: 'error',
              message: 'Failed to add Team Role'
            })
            console.error('Error addEditDone add', error)
          })
        } else {
          this.$store.direct.dispatch.abilities.updateRole({
            id: this.selectedTeamRoleId,
            role: teamRole
          }).then(() => {
            this.$message({
              type: 'success',
              message: 'Team Role updated'
            })
          }).catch(error => {
            this.$message({
              type: 'error',
              message: 'Failed to update Team Role'
            })
            console.error('Error addEditDone update', error)
          })
        }
      }
      this.closeAddEditModal()
    },
    closeAddEditModal () {
      this.$emit('newDialogClosed', true)
      this.showAddEditModal = false
    },
    isStandardRole (roleId: string): boolean  {
      return Object.values(AbilityRole).includes(roleId as AbilityRole)
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-button': Button,
    AddEditTeamRole
  }
})
